import axios from 'axios'
import JsSha from 'jssha'
axios.defaults.headers.post['Content-Type'] = 'text/plain'
window.bluetoothTips = true
export default {
  reqData: function (url, data, res, err) {
    axios.post(url, data, { headers: { 'Content-Type': 'text/plain' } }).then(res, err)
  },
  getPasswords: function (password) {
    let shaobj = new JsSha('SHA-1', 'TEXT')
    shaobj.update(password)
    return shaobj.getHash('HEX')
  },
  GetIndex (arr, min) {
    /**
     * 获取 特定点 与 线段距离最短的 index 值
     */
    let index = null;
    for(var i=0;i<arr.length;i++){
      if(arr[i] == min){
        index = i;
        break;
      }
    }
    return index;
  },
  GetTranslate (a, b) {
    /**
     * 获取2个定位点的长度
     */
    var ablng = Math.abs(a.lng - b.lng);
    var ablat = Math.abs(a.lat - b.lat);
    return Math.sqrt(ablng * ablng + ablat * ablat);
  },
  openMap: function (opt, flag) {
    // webview
    var w = plus.webview.create('./static/maps/maps.html', 'mapsId', {
      position: 'absolute',
      top: '45px',
      left: 0,
      right: 0,
      bottom: 0
    }, {
      preload: {
        option: opt,
        flag: flag // 0 司机 1 乘客
      }
    })
    w.show() // 显示窗口
  },
  distanceCompute: function (self, target, radius, completed, outRAIL) {
    let selfPoint = new plus.maps.Point(self.longitude, self.latitude)
    let targetPoint = new plus.maps.Point(target.longitude, target.latitude)
    // alert(self.latitude+"_"+self.longitude+"_"+target.latitude+"_"+target.longitude)
    plus.maps.Map.calculateDistance(targetPoint, selfPoint, function (event) {
      var distance = event.distance // 转换后的距离值
      //console.log('当前半径:' + radius + '距离:' + distance)
      if (parseInt(radius) >= distance) {
        // 在半径内
        completed()
      } else {
        // 在半径外
        typeof outRAIL === 'function' ? outRAIL() : false
      }
    }, function (e) {
      console.log('Failed:' + JSON.stringify(e))
    })
  },
  GetDeviation (pointArr) {
  },
  tts (text) {
    if (window.mytts) { console.log("音频是否播放完毕:", window.mytts.ended), window.mytts.pause() }
    window.mytts = new Audio('http://tts.baidu.com/text2audio?cuid=baiduid&lan=zh&ctp=1&pdt=311&tex=' + text)
    window.mytts.play()
  },
  printVal(json,res){
    let mac_address = localStorage.getItem("bleId");
      console.log('打印测试'+mac_address);
      if (!mac_address && window.bluetoothTips) {  
        alert('未选择蓝牙打印机');
        window.bluetoothTips = false;
        return;  
      }  
      var main = plus.android.runtimeMainActivity();  
      var BluetoothAdapter = plus.android.importClass("android.bluetooth.BluetoothAdapter");  
      var UUID = plus.android.importClass("java.util.UUID");  
      var uuid = UUID.fromString("00001101-0000-1000-8000-00805F9B34FB");  
      var BAdapter = BluetoothAdapter.getDefaultAdapter();  
      var device = BAdapter.getRemoteDevice(mac_address);  
      plus.android.importClass(device);  
      var bluetoothSocket = device.createInsecureRfcommSocketToServiceRecord(uuid);  
      plus.android.importClass(bluetoothSocket);  
  
      if (!bluetoothSocket.isConnected()) {  
        console.log('检测到设备未连接，尝试连接....');  
        bluetoothSocket.connect();  
      }  
  
      console.log('设备已连接'+bluetoothSocket.isConnected());  
  
      if (bluetoothSocket.isConnected()) {  
          console.log('进入打印  1');
          var outputStream = bluetoothSocket.getOutputStream();  
          console.log('进入打印  2');
          plus.android.importClass(outputStream);  
          console.log('进入打印  3');
          // var string = "! 0 200 200 210 1\r\n";
          // string += "TEXT 2 0 100 40 Hdddd sdfdsfdsf\r\n";
          // string += "FORM\r\n";
          // string += "PRINT\r\n";
          // var string = "! 100 203 203 350 1\r\n";
          // string += ";TEXT simhei.ttf 0 5 25 TestSample\r\n";
          // string += ";第1行 条形码 y100\r\n";
          // string += "BOX 30 40 200 170 1\r\n";
          // string += "BOX 200 40 590 170 1\r\n";
          // string += "BOX 30 170 590 350 1\r\n";
          // string += "CENTER\r\n";
          // string += "B 128 1 1 70 80 50 550002308471245\r\n";
          // string += "ST simhei.ttf 10 10 80 130 550002308471245\r\n";
          // string += "LEFT\r\n";
          // string += "ST simhei.ttf 18 18 40 80 不合格\r\n";
          // string += "ST simhei.ttf 10 10 60 180 编 码：8100.2000021790\r\n";
          // string += "ST simhei.ttf 10 10 60 210 描 述：脱氧铜板 GB/T2040 TP1-M20 16\r\n";
          // string += "ST simhei.ttf 10 10 60 240 炉 号：1925001\r\n";
          // string += "ST simhei.ttf 10 10 60 270 批 号：-\r\n";
          // string += "ST simhei.ttf 10 10 60 300 质证号：NP200610   有效期：2020-12-20\r\n";
          // string += "CENTER\r\n";
          // string += "B QR 70 40 M 2 U 6\r\n"; // 70,80 x坐标，y坐标 M2 U大小
          // string += "MA,ABC123\r\n";
          // string += "ENDQR\r\n";
          // string += "PRINT\r\n";
            
				var string = "^XA\r\n";
            string += "^FO75,10\r\n";
            string += "^BQ,2,6\r\n";
            string += "^FDLA, "+json.code+" ^FS\r\n";
            string += "^LH40,20\r\n";
            string += "^FO40,170^AD,24^FD"+json.code+"^FS ^PQ "+json.number+"\r\n";
            string += "^XZ\r\n";

        console.log('进入打印  4');
        var bytes = plus.android.invoke(string, 'getBytes', 'UTF-8');  
        console.log('进入打印  5');
        outputStream.write(bytes);  
        console.log('进入打印  6');
        outputStream.flush();  
        console.log('进入打印  7');
        device = null //这里关键  
        console.log('进入打印  8');
        bluetoothSocket.close(); //必须关闭蓝牙连接否则意外断开的话打印错误  
        console.log('进入打印  9');
        (res && res instanceof Function) && res(); 
      }
  },
  printValVin(json,res){
    let mac_address = localStorage.getItem("bleId");
      console.log('打印测试'+mac_address);
      if (!mac_address) {  
        alert('未选择蓝牙打印机');
        window.bluetoothTips = false;
        return;  
      }  
      var main = plus.android.runtimeMainActivity();  
      var BluetoothAdapter = plus.android.importClass("android.bluetooth.BluetoothAdapter");  
      var UUID = plus.android.importClass("java.util.UUID");  
      var uuid = UUID.fromString("00001101-0000-1000-8000-00805F9B34FB");  
      var BAdapter = BluetoothAdapter.getDefaultAdapter();  
      var device = BAdapter.getRemoteDevice(mac_address);  
      plus.android.importClass(device);  
      var bluetoothSocket = device.createInsecureRfcommSocketToServiceRecord(uuid);  
      plus.android.importClass(bluetoothSocket);  
  
      if (!bluetoothSocket.isConnected()) {  
        console.log('检测到设备未连接，尝试连接....');  
        bluetoothSocket.connect();  
      }  
  
      console.log('设备已连接'+bluetoothSocket.isConnected());  
  
      if (bluetoothSocket.isConnected()) {  
          console.log('进入打印  1');
          var outputStream = bluetoothSocket.getOutputStream();
          console.log('进入打印  2');
          plus.android.importClass(outputStream);
          console.log('进入打印  3');
          // var string = "! 0 200 200 210 1\r\n";
          // string += "TEXT 2 0 100 40 Hdddd sdfdsfdsf\r\n";
          // string += "FORM\r\n";
          // string += "PRINT\r\n";
          // var string = "! 100 203 203 350 1\r\n";
          // string += ";TEXT simhei.ttf 0 5 25 TestSample\r\n";
          // string += ";第1行 条形码 y100\r\n";
          // string += "BOX 30 40 200 170 1\r\n";
          // string += "BOX 200 40 590 170 1\r\n";
          // string += "BOX 30 170 590 350 1\r\n";
          // string += "CENTER\r\n";
          // string += "B 128 1 1 70 80 50 550002308471245\r\n";
          // string += "ST simhei.ttf 10 10 80 130 550002308471245\r\n";
          // string += "LEFT\r\n";
          // string += "ST simhei.ttf 18 18 40 80 不合格\r\n";
          // string += "ST simhei.ttf 10 10 60 180 编 码：8100.2000021790\r\n";
          // string += "ST simhei.ttf 10 10 60 210 描 述：脱氧铜板 GB/T2040 TP1-M20 16\r\n";
          // string += "ST simhei.ttf 10 10 60 240 炉 号：1925001\r\n";
          // string += "ST simhei.ttf 10 10 60 270 批 号：-\r\n";
          // string += "ST simhei.ttf 10 10 60 300 质证号：NP200610   有效期：2020-12-20\r\n";
          // string += "CENTER\r\n";
          // string += "B QR 70 40 M 2 U 6\r\n"; // 70,80 x坐标，y坐标 M2 U大小
          // string += "MA,ABC123\r\n";
          // string += "ENDQR\r\n";
          // string += "PRINT\r\n";
            
				var string = "^XA\r\n";
            string += "^FO75,10\r\n";
            string += "^BQ,2,6\r\n";
            string += "^FDLA, "+json.vin+" ^FS\r\n";
            string += "^LH40,20\r\n";
            string += "^FO40,155^AD,24^FD"+json.vin+"^FS\r\n";
            string += "^FO40,180^AD,24^FD"+json.code+"^FS ^PQ "+json.number+"\r\n";
            string += "^XZ\r\n";

        console.log(string);

        console.log('进入打印  4');
        var bytes = plus.android.invoke(string, 'getBytes', 'UTF-8');  
        console.log('进入打印  5');
        outputStream.write(bytes);  
        console.log('进入打印  6');
        outputStream.flush();  
        console.log('进入打印  7');
        device = null //这里关键
        console.log('进入打印  8');
        bluetoothSocket.close(); //必须关闭蓝牙连接否则意外断开的话打印错误  
        console.log('进入打印  9');
        (res && res instanceof Function) && res();
      }
  }
}



// WEBPACK FOOTER //
// ./src/common/common.js